import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';

/**
 * Clase base para los Servicios de datos.
 */
export abstract class ServicioDatosBase {

    constructor(protected http: HttpClient) {

    }

    /**
    * 
    * @param url 
    * @param parametros 
    */
    public get<T>(url: string, parametros: any) {

        console.log('url -->> ', url);
        console.log('parametros -->> ', parametros);

        return this.http.get<T>(url, { params: parametros });
    }

    /**
     * 
     * @param url 
     * @param parametros 
     */
    public post<T>(url: string, parametros: any, httpHeaders: any): Observable<any> {

        console.log('url -->> ', url);
        console.log('parametros -->> ', parametros);

        return this.http.post<T>(url, parametros, httpHeaders);
    }

    /**
     * 
     * @param url
     * @param parametros
     * @param httpHeaders
     */
    public postFile<T>(url: string, formData: FormData) {

        console.log('url -->> ', url);
       
        let headers = new HttpHeaders();

        headers.append('Content-Type', 'multipart/form-data');

        headers.append('Accept', 'application/json');

        return this.http.post<T>(url, formData, { headers: headers });
    }


    /**
     * 
     * @param parametros 
     * @param nombreParametro 
     * @param valorParametro 
     */
    protected addParameter(parametros: HttpParams, nombreParametro: string, valorParametro: any): HttpParams {

        if (parametros != undefined && nombreParametro != undefined) {

            let value = valorParametro;

            if (valorParametro == undefined) {
                value = '';
            }

            parametros = parametros.set(nombreParametro, value);
        }

        return parametros;

    }

}
